<template>
    <div>
        <div class="reconstruction-challenge-registration-contact">
            <h2 class="form-title">Kontakt na vás</h2>

            <div class="basicForm__row basicForm__item">
                <label for="fullName">Jméno a příjmení</label>
                <input type="text" class="button view-bordered" id="fullName" v-model="fullName">
            </div>
            <div class="error-message" v-if="getFieldError('fullName')">
                <p>{{getFieldError('fullName')}}</p>
            </div>

            <div class="basicForm__row basicForm__item">
                <label for="city">Město realizace projektu</label>
                <input type="text" class="button view-bordered" id="city" v-model="city">
            </div>
            <div class="error-message" v-if="getFieldError('city')">
                <p>{{getFieldError('city')}}</p>
            </div>

            <div class="basicForm__row basicForm__item">
                <label for="email">E-mail</label>
                <input type="email" class="button view-bordered" id="email" v-model="email">
            </div>
            <div class="error-message" v-if="getFieldError('email')">
                <p>{{getFieldError('email')}}</p>
            </div>

            <div class="basicForm__row basicForm__item">
                <label for="phone">Telefon</label>
                <input class="button view-bordered" type="phone" id="phone" v-model="phone">
            </div>
            <div class="error-message" v-if="getFieldError('phone')">
                <p>{{getFieldError('phone')}}</p>
            </div>
        </div>
        <div class="reconstruction-challenge-registration-aboatProject">
            <h2 class="form-title">O vašem projektu</h2>

            <div class="basicForm__row basicForm__item">
                <label for="name">Pojmenujte váš projekt (názvem, pod kterým bude zobrazen na stránkách)</label>
                <input type="text" class="button view-bordered" id="name" v-model="name">
            </div>
            <div class="error-message" v-if="getFieldError('name')">
                <p>{{getFieldError('name')}}</p>
            </div>

            <div class="basicForm__row basicForm__item">
                <label for="description">Prozraďte nám svůj příběh, proč chcete rekonstruovat.<br> Co vás k tomu vede a jaká je vaše představa o výsledné podobě proměny.</label>
                <textarea class="button view-bordered" id="description" v-model="description"></textarea>
            </div>
            <div class="error-message" v-if="getFieldError('description')">
                <p>{{getFieldError('description')}}</p>
            </div>

            <reconstruction-challenge-file-upload section="interior_before" title="Fotka prostoru, který chcete rekonstruovat (jpg, png)"/>
            <reconstruction-challenge-file-upload section="exterior_before" title="Fotka domu či byt zvenku (jpg, png)"/>
            <reconstruction-challenge-file-upload section="top_view_before" title="Nákres půdorysu před rekonstrukcí (jpg, png, postačí rukou)"/>
            <reconstruction-challenge-file-upload section="top_view_after" title="Nákres půdorysu po rekonstrukci (jpg, png, postačí rukou)"/>
            <div class="error-message" v-if="getFieldError('files')">
                <p>{{getFieldError('files')}}</p>
            </div>
            <div class="checkboxes">
                <div class="basicForm__row basicForm__item">
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox-native" v-model="notOwner">
                        <span class="checkbox-control"></span>
                        <span class="checkbox-label">
                        nejsem vlastník nebo uživatel bytu/domu, kde bude rekonstrukce probíhat
                    </span>
                    </label>
                    <div class="owner" v-if="notOwner">
                        <div class="basicForm__row basicForm__item">
                            <label for="ownerInfo">Osoba vlastníka a váš vztah k němu</label>
                            <textarea class="button view-bordered" id="ownerInfo" v-model="ownerInfo"></textarea>
                        </div>
                        <div class="error-message" v-if="getFieldError('ownerInfo')">
                            <p>{{getFieldError('ownerInfo')}}</p>
                        </div>
                    </div>
                </div>

                <div class="basicForm__row basicForm__item">
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox-native" v-model="rules">
                        <span class="checkbox-control"></span>
                        <span class="checkbox-label">
                        souhlasím s <a href="https://www.rigips.cz/rekonstrukcni-vyzva/pravidla/" target="_blank" title="Podmínky soutěže">podmínkami soutěže</a>
                    </span>
                    </label>
                </div>
                <div class="error-message" v-if="getFieldError('rules')">
                    <p>{{getFieldError('rules')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';
    import {mapGetters} from 'vuex';
    import find from 'lodash/find';
    import isUndefined from 'lodash/isUndefined';
    import ReconstructionChallengeFileUpload from './FileUpload';

    export default {
        name:       'ReconstructionChallengeRegistrationForm',
        components: { ReconstructionChallengeFileUpload },
        computed:   {
            ...mapFields('reconstructionChallenge', [
                'form.data.fullName',
                'form.data.city',
                'form.data.phone',
                'form.data.email',
                'form.data.project.name',
                'form.data.project.description',
                'form.data.notOwner',
                'form.data.ownerInfo',
                'form.data.rules',
            ]),
            ...mapGetters('reconstructionChallenge', ['errors']),
        },
        methods:    {
            getFieldError(field) {
                const error = find(this.errors, error => field === error.field);
                if (!isUndefined(error)) {
                    return error.msg;
                }
                return null;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/reconstruction-challenge/Form.vue